export default "__VITE_ASSET__DMzEnWzr__"